<template>
  <div class="[ upload-file-avatar ] position-absolute">
    <div class="[ upload-has-avatar-wrap ]">
      <div class="position-absolute d-flex flex-column">
        <div class="text-center">
          <i class="fa-regular fa-image fa-lg text-white text-center"></i>
        </div>
        <p class="mb-0 text-center">Replace Image</p>
      </div>

      <img
        :src="imageUrl"
        width="132"
        height="132"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      imageUrl: {
        type: String,
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>